<!-- Migrated from legacy/Plus/Plus/About/index.shtml; history merged from /collective -->

<template>
  <h4>About the project</h4>
  <p>
    'VizbiPlus: Visualising the Future of Biomedicine' was a project funded by the
    <em>Inspiring Australia</em> government initiative, the
    <a href="https://www.garvan.org.au">Garvan Institute of Medical Research</a>, the
    <a href="https://www.wehi.edu.au">Walter &amp; Eliza Hall Institute</a>, and
    <a href="https://www.csiro.au">CSIRO</a>. Its goal was to train three scientists to create
    scientifically accurate 3D animations that explain the latest biomedical research in a way
    that inspires and engages the general public, and then present this work in public events to
    maximise the reach of the work.
  </p>
  <router-link to="/Posters/2013/B06" title="Click to view a zoomable version of the poster">
    <img
      class="poster"
      src="/Plus/img/VIZBIplus-poster.jpg"
      alt="VizbiPlus poster" />
  </router-link>
  <p>
    The project was led jointly by
    <a href="https://www.linkedin.com/in/kate-patterson-955b0b12/" target="_blank" rel="noopener"
    >Kate Patterson</a
    > at the Garvan Institute,
    <router-link to="/2026/Masterclass#Se%C3%A1n_O'Donoghue">Seán O&rsquo;Donoghue</router-link>
    at CSIRO and Garvan, and molecular animator
    <router-link to="/2025/Masterclass#Drew_Berry">Drew Berry</router-link> at the Walter and
    Eliza Hall Institute, with design lead
    <router-link to="/2026/People#Christian_Stolte">Christian Stolte</router-link>.
  </p>
  <p>
    Drew Berry and his colleague at the Walter and Eliza Hall Institute, Etsuko Uno, trained a new
    generation of science animators, including
    <router-link to="/2026/People#Maja_Divjak">Maja Divjak</router-link> and
    <a
      href="https://www.youtube.com/playlist?list=PLU8YTKoEQCPO2J-YiCHZiVyG_fMROZJn2"
      target="_blank"
      rel="noopener"
    >Chris Hammang</a
    >. The animations created by the project were presented at a series of high-profile
    VizbiPlus outreach events at the participating organisations from 2013 to 2017 (see
    <router-link to="/Plus/Events">Events</router-link>). The animations were also made available
    for television broadcast and online education.
  </p>
  <p>
    "To see a process happening, rather than hear or read about it, can make a huge difference in
    people's understanding of complex scientific concepts and medical problems," said Kate
    Patterson, a scientist and animator at Garvan. "This is a great opportunity to communicate
    science &mdash; especially with people who may not have been exposed to these ideas in the
    past."
  </p>
  <p>
    Emmy award winner Drew Berry, who had many years of experience creating scientific
    animations, used the same animation software as Pixar Animation Studios and video game
    creators. His work had reached large national audiences through television news bulletins,
    science documentaries and installations in museums, as well as global audiences through
    YouTube and international film festivals.
    <a href="https://www.wehi.edu.au/education/wehitv/">Click here to see examples of previous
      work by Drew Berry and Etsuko Uno</a>.
  </p>
  <h4>After the project</h4>
  <p>
    Animations from the project later formed part of larger public installations, including the
    Vivid Sydney projection
    <a href="https://vimeo.com/275568851" target="_blank" rel="noopener">Beautiful and Dangerous</a>
    (2018). Alongside the animation work, the wider VIZBI community continued to organise
    <router-link to="/Showcases">VIZBI Showcase</router-link> events &mdash; public evenings that
    bring together researchers, designers and artists to explore how visualisation can
    communicate complex biological ideas.
  </p>
  <p>
    Over time, the network of collaborators that formed around VizbiPlus evolved into the
    <router-link to="/collective">VIZBI Collective</router-link>: a flexible group that forms
    around emerging projects, whenever the opportunity and the people align.
  </p>
</template>

<style scoped>
img.poster {
  width: 100%;
  margin-bottom: 20px;
  border-radius: 4px;
}
</style>
